import * as yup from "yup";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  appointmentId: yup.number().required(),
  allSubsequent: yup.boolean().required(),
});

export function useDeleteOutOfOfficeAppointmentMutation(options = {}) {
  var queryClient = useQueryClient();

  return useMutation(
    (payload) => {
      const req = requestSchema.validateSync(payload, { strict: true });

      return http.post(HTTP_ENDPOINTS.appointments.deleteOutOfOffice(), {
        appointment_id: req.appointmentId,
        all_following: Number(req.allSubsequent),
      });
    },
    {
      ...options,
      onSuccess: (...args) => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.appointments.appointment],
        });
        options.onSuccess?.(...args);
      },
    },
  );
}
